import { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import * as EmptySectionContent from 'src/components/common/EmptySectionContent';
import {
  AdPlatformCatalogDataContextProvider,
  useAdPlatformCatalogDataContext,
} from 'src/contexts/AdPlatformCatalogDataContext';
import { Content } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { Stack } from 'src/core/ui';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { SearchSolidIcon } from 'src/svgs/Viagogo';
import { AdCampaignQueryParam } from 'src/utils/constants/constants';
import { ContentId } from 'src/utils/constants/contentId';
import { removeDeepLinkUrlPartsFromRelativeUrl } from 'src/utils/deepLinkUtils';
import { SomethingWentWrong } from 'src/views';

import { getDefaultReturnUrl } from '../InventoryEvent/constants';
import { MainRoute } from '../MainRoute';
import { AdGroupsToolbar } from '../SponsoredListings/AdGroupsToolbar/AdGroupsToolbar';

export const AdCampaign = () => {
  const [searchParams] = useSearchParams();
  const adCampaignId = Number(searchParams.get(AdCampaignQueryParam));

  if (!adCampaignId) {
    return null;
  }

  return (
    <AdPlatformCatalogDataContextProvider>
      <AdGroupsContent adCampaignId={adCampaignId} />
    </AdPlatformCatalogDataContextProvider>
  );
};

export const AdGroupsContent = ({ adCampaignId }: { adCampaignId: number }) => {
  const location = useLocation();

  const returnUrl = useMemo(() => {
    const relativeUrl =
      (location.state as { returnUrl?: string })?.returnUrl ||
      getDefaultReturnUrl(adCampaignId.toString());

    return removeDeepLinkUrlPartsFromRelativeUrl(relativeUrl, [
      AdCampaignQueryParam,
    ]);
  }, [adCampaignId, location.state]);

  const { errorInfo: errorInfoCatalog } = useAdPlatformCatalogDataContext();

  const errorInfo = errorInfoCatalog;

  return (
    <DialogProvider>
      <LayoutContent mainRoute={MainRoute.SponsoredListings} routeTitle="">
        <Stack direction="column" width="full" height="full">
          {errorInfo && (
            <SomethingWentWrong
              header={errorInfo.errorHeader}
              message={
                errorInfo.errorMessage ?? (
                  <Content id={ContentId.FailToLoadListContent} />
                )
              }
            />
          )}
          {!errorInfo && (
            <>
              <AdGroupsToolbar returnUrl={returnUrl ?? undefined} />

              <EmptySectionContent.Root
                icon={
                  <EmptySectionContent.SolidIconContainer>
                    <SearchSolidIcon />
                  </EmptySectionContent.SolidIconContainer>
                }
              >
                <EmptySectionContent.Label>
                  <Content id={ContentId.NoResultFound} />
                </EmptySectionContent.Label>
                <EmptySectionContent.DetailMessage>
                  <Content id={ContentId.NoEventsMatching} />
                </EmptySectionContent.DetailMessage>
              </EmptySectionContent.Root>
            </>
          )}
        </Stack>
      </LayoutContent>
    </DialogProvider>
  );
};
